import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PipeLineService {

  constructor(private api: ApiService) { }


  getAllPipeLine(data: any): Observable<any> {
    return this.api.post(environment.getAllPipeLine, data);
  }

  createPipeLine(data: any): Observable<any> {
    return this.api.post(environment.createPipeLine, data);
  }

  updatePipeLine(data: any): Observable<any> {
    return this.api.post(environment.updatePipeLine, data);
  }

  deletePipeLine(data: any): Observable<any> {
    return this.api.post(environment.deletePipeLine, data);
  }

}


